(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('CompanyDialogController', CompanyDialogController);

    CompanyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Company', 'Location', 'Contact', 'Principal', 'showTypes'];

    function CompanyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Company, Location, Contact, Principal, showTypes) {
        var vm = this;

        vm.company = entity;
        vm.showTypes = showTypes;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.locations = Location.query();
        vm.contacts = Contact.query();

        if (vm.company.id === null) {
            vm.activity = 'new';
            vm.company.createdOn = new Date();
            vm.company.modifiedOn = vm.company.createdOn;
        } else {
            vm.activity = 'edit';
            vm.company.modifiedOn = new Date();
        }

        Principal.identity().then(function (account) {
            vm.account = account;
            vm.isAuthenticated = Principal.isAuthenticated;
            if (vm.activity === 'new') {
                vm.company.createdBy = account.login;
                vm.company.modifiedBy = vm.company.createdBy;
            } else {
                vm.company.modifiedBy = account.login;
                vm.company.modifiedOn = new Date();
            }
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.company.id !== null) {
                Company.update(vm.company, onSaveSuccess, onSaveError);
            } else {
                Company.save(vm.company, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ccsTrApp:companyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdOn = false;
        vm.datePickerOpenStatus.modifiedOn = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
